import SportManager from './SportManager'
import Bus from '../../bus'

import {
  SPORTSBOOK_STATE_UPDATE,
  SPORT_STATE_UPDATE,
  CATEGORY_STATE_UPDATE,
  TOURNAMENT_STATE_UPDATE,
  EVENT_STATE_UPDATE
} from '../../actions'

import { isEmpty } from 'lodash'

const $sport = new SportManager()

export default $sport

Bus.on(Bus.events.socket.open, ({ connectionId }) => {
  $sport.sportsbookBroadcaster.broadcastAll({
    type: SPORTSBOOK_STATE_UPDATE,
    payload: {
      connected: true,
      connectionId
    }
  })
})

Bus.on(Bus.events.socket.closed, () => {
  $sport.sportsbookBroadcaster.broadcastAll({
    type: SPORTSBOOK_STATE_UPDATE,
    payload: {
      connected: false
    }
  })
})

/*
  Redirecting events sport service updates in tournament scope
  to the tournament context by id
*/
Bus.on(Bus.events.sport.tournamentEventSportServiceUpdate, ({ data }) => {
  const {
    tournamentId,
    events
  } = data

  if (isEmpty(events)) { return }

  $sport.statusBroadcaster.emit(`tournament:${tournamentId}`, {
    events
  })
})

Bus.on(Bus.events.sport.sportEventsCount, ({ data, id }) => {
  // Updating sport directly listeners
  $sport.dataBroadcaster.emit(`sport:${data.id}`, {
    type: SPORT_STATE_UPDATE,
    payload: data
  })

  // Updating sport in sportsbook state
  $sport.counterBroadcaster.emit(`sport:${id}`, data)
})

Bus.on(Bus.events.sport.categoryEventsCount, ({ data, id }) => {
  // Updaing category events count inside category entity
  $sport.dataBroadcaster.emit(`category:${data.id}`, {
    type: CATEGORY_STATE_UPDATE,
    payload: data
  })

  // Broadcast category events count in sport categories
  $sport.counterBroadcaster.emit(`sport:${id}`, data)
})

Bus.on(Bus.events.sport.tournamentEventsCount, ({ data, id }) => {
  // Broadcasting counter update directly to tournament state
  $sport.dataBroadcaster.emit(`tournament:${data.id}`, {
    type: TOURNAMENT_STATE_UPDATE,
    payload: data
  })

  // Broadcasting counter update to categories that subscribed for tournaments
  $sport.counterBroadcaster.emit(`category:${id}`, data)
})

Bus.on(Bus.events.sport.eventUpdate, ({ data }) => {
  if (isEmpty(data.events)) { return }

  // Events wrapped with tournament
  Object.keys(data.events).forEach(eventId => {
    const eventUpdate = data.events[eventId]

    Bus.emit(Bus.events.sport.sportEventUpdate, eventUpdate)

    $sport.dataBroadcaster.emit(`event:${eventId}`, {
      type: EVENT_STATE_UPDATE,
      payload: eventUpdate
    })
  })
})

Bus.on(Bus.events.sport.tournamentUpdate, ({ data }) => {
  if (isEmpty(data.events)) { return }

  // Events wrapped with tournament
  Object.keys(data.events).forEach(eventId => {
    const eventUpdate = data.events[eventId]

    Bus.emit(Bus.events.sport.sportEventUpdate, eventUpdate)

    $sport.dataBroadcaster.emit(`event:${eventId}`, {
      type: EVENT_STATE_UPDATE,
      payload: eventUpdate
    })
  })
})
